import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ROUTESPATH } from '@core/config/constants';
import { TokenService } from '@services/generic/token.service';

@Injectable({
  providedIn: 'root',
})
export class JwtGuard implements CanActivate {
  constructor(
    private router: Router,
    private readonly tokenService: TokenService
  ) {}

  async canActivate() {
    return await this.tokenService
      .validToken()
      .then(() => {
        return true;
      })
      .catch(() => {
        this.router.navigate([ROUTESPATH.LOGIN]);
        return false;
      });
  }
}
